import './style.css';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {Draw, Modify} from 'ol/interaction.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import TileWMS from 'ol/source/TileWMS.js';
import {toLonLat, fromLonLat, transformExtent} from 'ol/proj.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon, Text} from 'ol/style.js';
import Overlay from 'ol/Overlay';

var poiFilePointer, infoFilePointer, pathFilePointer;
poiFilePointer = infoFilePointer = pathFilePointer = 'node_modules/data/geojson/';

var xmlhttp = new XMLHttpRequest();
xmlhttp.open("GET", 'geojsonpointers.txt', false);
xmlhttp.send();
if (xmlhttp.status==200) {
	var pointerArray = xmlhttp.responseText.split("\n");
	poiFilePointer += pointerArray[0];
	infoFilePointer += pointerArray[1];
	pathFilePointer += pointerArray[2];
}

const pauwelspadLonLat = [5.1328974,51.6119169];
const pauwelspadWebMerc = fromLonLat(pauwelspadLonLat);
const extent = transformExtent([4.8, 51.5, 5.5, 51.75], 'EPSG:4326', 'EPSG:3857');

const raster = new TileLayer({
	source: new OSM(),
	extent: extent,
});

function pathStyleFunction(feature) {
	var colorInside, colorOutside;
    switch(feature.get("categorie")) {
    	case "Hoofdpad Verhard":
    		colorOutside = '#332288';
    		colorInside = '#DDCC77';
    		break;
    	case "Hoofdpad Onverhard":    	
    		colorOutside = '#117733';
    		colorInside = '#DDCC77';
    		break;
    	case "Ommetje Verhard":    	
    		colorOutside = '#332288';
    		colorInside = '#CC6677';
    		break;    		
    	case "Ommetje Onverhard":    	
    		colorOutside = '#117733';
    		colorInside = '#CC6677';
    		break;		
    	case "Laarzenpad":    	
    		colorOutside = '#88CCEE';
    		colorInside = '#332288';
    		break;
    	case "HondenNT":    	
    		colorOutside = '#882255';
    		colorInside = '#DDCC77';
    		break;
    	default:
    		colorOutside = '#008e70';
    		colorInside = '#008e70';
			break;
   	}
   	var pathStyle = [new Style({                
		 stroke : new Stroke({ 
		     color: colorOutside,
		     width: 6,
		     lineCap: 'square',
		}),
	  }),
	new Style({                
		 stroke : new Stroke({ 
		     color: colorInside,
		     width: 2,
		     lineCap: 'square',
		}),
	})];  	
  	return pathStyle;  	
}

const pathSource = new VectorSource({
    format: new GeoJSON(),
    url: pathFilePointer,
  });
  
const pauwelspadlayer = new VectorLayer({
  source: pathSource,
  style: pathStyleFunction,
});

const kpwlayer = 
    new TileLayer({
    	extent: extent,
    	opacity: 0.5,
        source: new TileWMS({
          url: 'https://service.pdok.nl/wandelnet/regionale-wandelnetwerken/wms/v1_0?version=1.3.0',
          params: {
            'format' : 'image/png',
            'layers' : 'wandelnetwerken',
            },
        }),
});

const kplayer = 
    new TileLayer({
    	extent: extent,
        source: new TileWMS({
          url: 'https://service.pdok.nl/wandelnet/regionale-wandelnetwerken/wms/v1_0?version=1.3.0',
          params: {
            'format' : 'image/png',
            'layers' : 'wandelknooppunten'         
            },
        }),
});

function poiStyleFunction(feature) {
    switch(feature.get("categorie")) {
		case "Horeca":
		    var iurl = "node_modules/data/icon/horeca.png";
		    break;
		case "Drinkwaterpunt":
		    var iurl = "node_modules/data/icon/tap-water-drink-water-tap.png";
		    break;
		case "BenB":
		    var iurl = "node_modules/data/icon/b&b.png";
		    break;
		case "Vakantiewoning":
		    var iurl = "node_modules/data/icon/237028.png";
		    break;
		case "Camping":
		    var iurl = "node_modules/data/icon/camping-tent.png";
		    break;
		case "Bushalte":
		    var iurl = "node_modules/data/icon/front-of-bus.png";
		    break;
		case "Kasteel":
		    var iurl = "node_modules/data/icon/castle.png";
		    break;
		case "Startlocatie":
		    var iurl = "node_modules/data/icon/start.png";
		    break;
		case "StartlocatieOmmetje":
		    var iurl = "node_modules/data/icon/startO.png";
		    break;
		case "Klooster":
		    var iurl = "node_modules/data/icon/klooster.png";
		    break;
		case "Uitzichtpunt":
		    var iurl = "node_modules/data/icon/uitzichtpunt.png";
		    break;
		case "HondenNT":
		    var iurl = "node_modules/data/icon/hondennt.png";
		    break;
		default:
		    var iurl = "node_modules/data/icon/new.png";
			break;
   	}
   	var poistyle = new Style({
    	image: new Icon({
	      src: iurl,
	      opacity: 1,
	      scale: 0.18
    	})
  	});
  	
  	return [poistyle];  	
}
 
const poiSource = new VectorSource({
    format: new GeoJSON(),
    url: poiFilePointer,
	attributions: ' &#169; De Groene Oen'
  });
  
const poilayer = new VectorLayer({
  source: poiSource,
  style: poiStyleFunction,
});

function infoStyleFunction(feature) {
    switch(feature.get("categorie")) {
		case "Verhalen":
		    var iurl = "node_modules/data/icon/verhalen.png";
		    break;
		case "Natuurinfo":
		    var iurl = "node_modules/data/icon/natuur.png";
		    break;
		case "Erfgoedinfo":
		    var iurl = "node_modules/data/icon/erfgoed.png";
		    break;
		default:
		    var iurl = "node_modules/data/icon/new.png";
			break;
   	}
   	var infostyle = new Style({
    	image: new Icon({
	      src: iurl,
	      opacity: 1,
	      scale: 0.2
    	})
  	});
  	
  	return [infostyle];  	
}

const infoSource = new VectorSource({
    format: new GeoJSON(),
    url: infoFilePointer,
  });

const infolayer = new VectorLayer({
  source: infoSource,
  style: infoStyleFunction,
});


const view = new View({
    center: pauwelspadWebMerc,
    zoom: 12.8,
    minZoom: 11.6,
  });
  
const map = new Map({
  layers: [raster, kpwlayer, pauwelspadlayer, kplayer, poilayer, infolayer],
  target: 'map',
  view: view,
});

//toggle features on off
document.getElementById("featureToggle").addEventListener('change', e => {
	if(e.target.checked){
		var features = poiSource.getFeatures();
		for(let i = 0; i<features.length; i++) {		
			if(features[i].get("categorie") == e.target.value) features[i].setStyle(null);
		}
	} else {
		var features = poiSource.getFeatures();
		for(let i = 0; i<features.length; i++) {		
			if(features[i].get("categorie") == e.target.value) features[i].setStyle(new Style({}));
		}
	}
});

/**
 * Popup
 **/
var
    container = document.getElementById('popup'),
    content_element = document.getElementById('popup-content'),
    closer = document.getElementById('popup-closer'),
    closerInfo = document.getElementById('infoPanelCloser');

closer.onclick = function() {
    overlay.setPosition(undefined);
    closer.blur();
    return false;
};
closerInfo.onclick = function() {
    if(document.getElementById('audioPlayer')) document.getElementById('audioPlayer').pause();
    document.getElementById('infoPanel').style.display = "none";
    closer.blur();
    return false;
};

var overlay = new Overlay({
    element: container,
    autoPan: true,
    offset: [0, -10]
});
map.addOverlay(overlay);

map.on('click', function(evt){
    //document.getElementById('info').innerHTML = '';
    const viewResolution = /** @type {number} */ (view.getResolution());

    //console.log(url)
    var feature = map.forEachFeatureAtPixel(evt.pixel,
      function(feature, layer) {
        return feature;
      });
    //console.log(feature);
    if (feature) {
        var geometry = feature.getGeometry();
        var coord = geometry.getCoordinates();
        
 		if (feature.get('categorie') == "Natuurinfo" || feature.get('categorie') == "Erfgoedinfo" || feature.get('categorie') == "Verhalen" ) {
 			content_element = document.getElementById('infoPanelContent');
 			content_element.innerHTML = null;
 			var propObject = feature.getProperties(),props;
			for (props in propObject) {
				if(props == "naam") {					
	    			content_element.innerHTML += propObject[props]+'<br />';
				}
				if(props == "tekst") {
					var newString = propObject[props].replace(/\[/g, '<br /><img class="infoImg" src="node_modules/data/images/');
					newString = newString.replace(/\]/g, '"></img>');
					content_element.innerHTML += newString + '<br />';	
				}
				if(props == "audioFile") {
					if(propObject[props] != "Geen Audio") {
						content_element.innerHTML += '<audio id="audioPlayer" controls> <source src="node_modules/data/audio/' + propObject[props] + '">Your browser does not support the audio element.</audio><br />';
					}
				}
				document.getElementById('infoPanel').style.display = "block";
    		}
 		} else {
 			content_element = document.getElementById('popup-content');
 			content_element.innerHTML = null;
 			var content = "";
 			var propObject = feature.getProperties(),props;
			for (props in propObject) {
				if(props == "naam" && propObject[props] != "") {					
	    			content = propObject[props]+'<br />' + content;
				}
				if(props == "adres" && propObject[props] != "") {					
	    			content += propObject[props]+'<br />';
				}
				if(props == "tel" && propObject[props] != "") {									
	    			content += '<a href="tel:' + propObject[props]+'" target="_blank">' + propObject[props]+ '</a><br />';
				}
				if(props == "url" && propObject[props] != "") {									
	    			content += '<a href="' + propObject[props]+'" target="_blank">' + propObject[props]+ '</a><br />';
				}
    		}
    		if(content != "") {
		        content_element.innerHTML = content;
		        overlay.setPosition(coord);
            }
        }
        //console.info(feature.getProperties());
    }
    
});



